import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { computed, Injectable } from '@angular/core';

@Injectable()
export class ServiceSettingsRiskTypeStore extends ComponentStoreV2Factory {
    riskTypes = computed<string[]>(() => {
        const item = this.data.getServiceSettings()?.items[0];
        return item?.data && JSON.parse(item.data).riskTypes || [];
    });
}
